export const EDITOR_PREFIX = 'editor';

export const TOGGLE_EXPAND_EXERCISE_CONTEXT = 'lessonExercises';
export const TOGGLE_EXPAND_EXERCISE_DEFAULT = true;

export const SET_VALIDATION_VISIBILITY = `${EDITOR_PREFIX}/set_validation_visibility`;
export const SET_VALIDATION_BUSY       = `${EDITOR_PREFIX}/set_validation_busy`;
export const TOGGLE_EXPAND             = `${EDITOR_PREFIX}/TOGGLE_EXPAND`;
